import { Navigate, Outlet } from 'react-router-dom'
import useAuthStore from '@/store/useAuthStore'

const PrivateRoute = () => {
  const { accessToken } = useAuthStore()

  return accessToken ? <Outlet /> : <Navigate to="/" replace />
}

export default PrivateRoute
